import {BaseIbanValidator} from './validator';

export {IbanDirective} from './directive';
export {IbanPipe} from './pipe';

export const IBAN_VALIDATORS = [BaseIbanValidator];
